import React, {useMemo} from 'react'
import { createTimeModel, useTimeModel } from "react-compound-timer";

function ExTimer({initialTime, startImmediately}) {
    const timer = useMemo(() => createTimeModel({
        initialTime: initialTime ?? 0,
        startImmediately: startImmediately ?? true
    }), [initialTime, startImmediately]);


    const { value } = useTimeModel(timer);

    return <>{value.m}:{value.s.toString().padStart(2, '0')}</>
}

export default ExTimer
